import React from 'react';
import { Reveal } from './ui/Reveal';
import { codes } from '../data/codes';
export function CodesSection() {
  return <section className="bg-champagne px-6 py-20 sm:py-28" data-id="element-34" data-mp="23dr95b4dzx32">
      <div className="mx-auto max-w-6xl" data-id="element-35" data-mp="28cca5crgqksk">
        <Reveal data-id="element-36" data-mp="28baneb1349v0">
          <div className="mx-auto max-w-2xl text-center" data-id="element-37" data-mp="28arh5rksr9wt">
            <h2 className="font-serif text-[1.75rem] font-light leading-tight text-ink sm:text-4xl" data-id="element-38" data-mp="2d32dkkgbwdkm">
              Tres códigos para comprender{' '}
              <em className="not-italic text-gold-dark" data-id="element-39" data-mp="2i3ygovsuvvoz">dónde estás hoy</em>
            </h2>
            <p className="mt-6 text-[17px] leading-relaxed text-ink-soft sm:text-[19px]" data-id="element-40" data-mp="2m1nwwhtmjwmg">
              Durante mi trabajo con mujeres he identificado tres áreas
              fundamentales que pueden ayudarte a observar tu momento actual
              desde una nueva perspectiva.
            </p>
          </div>
        </Reveal>

        <ul className="mt-14 grid gap-6 lg:grid-cols-3 lg:gap-7" data-id="element-41" data-mp="11nm1xgjjubsw">
          {codes.map((code, i) => <li key={code.key} className="flex" data-id="element-42" data-mp="3g4gue1bothrz" data-mpi={i}>
              <Reveal delay={i * 0.1} className="flex w-full" data-id="element-43" data-mp="3g6be5cb833uh">
                <article className="flex w-full flex-col rounded-[1.5rem] border border-gold/30 bg-ivory p-8 shadow-soft sm:p-9" data-id="element-44" data-mp="3bds1chkd0cqq">
                  <p className="font-serif text-4xl font-light leading-none text-gold" data-id="element-45" data-mp="36fgqq4m8py7g">
                    {code.number}
                  </p>
                  <h3 className="mt-5 text-[11px] font-semibold uppercase tracking-[0.22em] text-gold-dark" data-id="element-46" data-mp="2y8fi3m0pwlp">
                    {code.name}
                  </h3>
                  <p className="mt-4 font-serif text-2xl font-light leading-snug text-ink" data-id="element-47" data-mp="3u5b2eiutpgq4">
                    {code.title}
                  </p>
                  <div className="mt-5 space-y-3.5" data-id="element-48" data-mp="3l4cxlyck956h">
                    {code.body.map(p => <p key={p} className="text-[16px] leading-relaxed text-ink-soft" data-id="element-49" data-mp="2eoanvgf4xmeh">
                        {p}
                      </p>)}
                  </div>
                </article>
              </Reveal>
            </li>)}
        </ul>

        <Reveal delay={0.2} data-id="element-50" data-mp="2g4ergptyouew">
          <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-xl font-light leading-snug text-ink sm:text-2xl" data-id="element-51" data-mp="2255l0hvk5eo4">
            La pregunta no es cuál de estos códigos necesitas.
            <br data-id="element-52" data-mp="268lg39rzb6yp" />
            <em className="not-italic text-gold-dark" data-id="element-53" data-mp="1sfm1da00tgs7">
              La pregunta es: ¿cuál está pidiendo tu atención en este momento?
            </em>
          </p>
        </Reveal>
      </div>
    </section>;
}